

const OurHeritageSection = () => {
  return (
    <>
      {/* New Section: Our Heritage */}
      <section
        className="w-full"
        style={{
          backgroundColor: '#F7F8FA',
          paddingTop: '16px',
          paddingBottom: '16px',
          textAlign: 'center'
        }}
      >
        <h2
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '32px',
            color: '#764F2B',
            fontWeight: '400'
          }}
        >
          Our Heritage
        </h2>
      </section>

      {/* Original Section */}
      <section
        id="our-heritage"
        className="relative w-full px-4 md:px-16"
        style={{
          backgroundColor: '#000000',
          backgroundImage: "url('/Landing Page/Our Heritage/bg.png')",
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          paddingTop: '160px',
          paddingBottom: '160px'
        }}
      >
      <div
        className="flex flex-col items-center text-center text-white max-w-7xl mx-auto"
        style={{
          fontFamily: 'Cardo, serif'
        }}
      >
        {/* Logo */}
        <div className="mt-0 md:mt-0">
          <img
            src="/Logo/Logo_White.png"
            alt="FGA Prestige Logo"
            width={322}
            height={100}
            className="object-contain"
            style={{ width: '322px', height: '100px' }}
          />
        </div>

        {/* Gap */}
        <div style={{ height: '80px' }}></div>

        {/* Main Heritage Paragraph */}
        <div
          className="flex items-start justify-center mt-0 md:mt-0 lg:mt-0"
        >
          <p
            className="max-w-4xl leading-relaxed font-normal"
            style={{
              color: '#CFBF9E',
              fontSize: '14px'
            }}
          >
            For a quarter of a century, FGA Prestige has woven legacy, expertise, and<br />
            vision into Asia's premier luxury lifestyle group.
          </p>
        </div>

        {/* Gap */}
        <div style={{ height: '80px' }}></div>

        {/* Built on Trust, Defined by Experience */}
        <div className="mt-0 md:mt-0 lg:mt-0">
          <h3 className="text-xl md:text-2xl lg:text-3xl text-white font-normal">
            Built on Trust, Defined by Experience
          </h3>
          <div className="flex items-start justify-center mt-4">
            <p
              className="max-w-4xl leading-relaxed font-normal text-white"
              style={{ fontSize: '14px' }}
            >
              We began our journey as FGA Trust—dedicated to protecting prosperity and building legacies for high-net-worth individuals and families. Through decades of guiding clients through life's most complex financial landscapes, we cultivated deep, lasting relationships with exceptional individuals—each seeking not just stewardship, but genuine care and understanding.
            </p>
          </div>
        </div>

        {/* Gap */}
        <div style={{ height: '80px' }}></div>

        {/* From Stewardship to Service */}
        <div className="mt-0 md:mt-0 lg:mt-0">
          <h3 className="text-xl md:text-2xl lg:text-3xl text-white font-normal">
            From Stewardship to Service
          </h3>
          <div className="flex items-start justify-center mt-4">
            <p
              className="max-w-4xl leading-relaxed font-normal text-white"
              style={{ fontSize: '14px' }}
            >
              With profound experience serving HNWI at the highest level, we listened closely to what truly matters. Beyond wealth, our clients yearned for something rarer: the gift of time and authentic peace of mind. Inspired by this calling, we founded FGA Prestige—transforming our trust heritage into a boutique concierge, designed to curate not only security but the world's finest experiences.
            </p>
          </div>
        </div>

        {/* Gap */}
        <div style={{ height: '80px' }}></div>

        {/* 25 Years of Connections & Care */}
        <div className="mt-0 md:mt-0 lg:mt-0">
          <h3 className="text-xl md:text-2xl lg:text-3xl text-white font-normal">
            25 Years of Connections & Care
          </h3>
          <div className="flex items-start justify-center mt-4">
            <p
              className="max-w-4xl leading-relaxed font-normal text-white"
              style={{ fontSize: '14px' }}
            >
              Over the years, we have meticulously built friendships and partnerships across continents—with leading brands, tastemakers, and artisan creators. These connections grant our members privileged access to the extraordinary: exclusive privileges, rare opportunities, and perfectly orchestrated moments, all delivered with impeccable discretion and personal warmth.
            </p>
          </div>
        </div>

      </div>
    </section>
    </>
  )
}

export default OurHeritageSection